import gql from 'graphql-tag';

const CurrentClaim = gql`
  query CurrentClaim(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    claim(id: $id) {
      id
      codeClaim
      reason
      reasonForAbandon
      token
      createdAt
      updatedAt
      courtHearingAt
      nebSentDate
      courtId
      courtName
      courtAddress
      lawyer {
        id
        name
        surname
      }
      nRg
      courtHearingAt
      courtDecisionDate
      paxAgreementAmount
      airlineAgreementAmount
      airlineAgreementDate
      settlementType
      legalFees
      refundFromAirlineDate
      refundFromLawyerDate
      refundFromLawyerAmountForPax
      refundFromLawyerLegalFeesAmount
      paxTransferDate
      paxToTransferAmount
      paxBankAccountHolder
      donatedAmount
      conciliationAt
      magicKey
      airlineAmicableAnswer
      airlinePreLitigationAnswer
      overallDelayAtDestination
      totalDelay
      flightId
      crmState
      passengerTicketId
      paxCompensationAmount
      maximumCompensationAmount
      correctedInformation
      travelerFormUrl
      testimonialUrl
      paymentUrl
      refundFromAirlineAmount
      refundFromAirlineDate
      refundToPaxAmount
      refundToPaxDate
      iban
      bicSwift
      paxPaypalId
      paxTransferChannel
      passengerComment
      airlineCustomerServiceEmail
      lawyer {
        id
        name
        lawFirm {
          id
          name
        }
      }
      litigationCountry
      passengerTicket {
        id
        pnr
        number
        passengerFirstName
        passengerLastName
        passengerPhone
        passengerEmail
        passengerLanguage
        employer
        profession
        gender
        nationality
        dateOfBirth
        street
        city
        postCode
        country
        widgetCommentFromPax
        bankInformation
        bankName
        organizationName
        affiliate {
          id
          name
        }
      }
      flight {
        id
        number
        localDepartureDate
        localArrivalDate
        airlineCode
        airline {
          name
          iata
        }
        airportOrigin {
          name
          iata
        }
        airportDestination {
          name
          iata
        }
      }
      affiliate {
        id
        name
      }
      claimsPassengerTicketConnection {
        edges {
          node {
            id
            promoCode {
              id
              code
              percentage
            }
            documentsConnection {
              edges {
                cursor
                node {
                  id
                  documentId
                  attachmentContentType
                  documentUrl
                  status
                  conflictsWithClaim
                  formAttributes
                  type
                  claimsPassengerTicket {
                    id
                    passengerTicket {
                      id
                      passengerFirstName
                      passengerLastName
                    }
                  }
                }
              }
            }
            loa {
              id
              myclaimUrl
              signedLoaDocumentUrl
            }
            passengerTicket {
              id
              pnr
              number
              passengerFirstName
              passengerLastName
              passengerPhone
              passengerEmail
              passengerLanguage
              employer
              profession
              gender
              nationality
              dateOfBirth
              street
              city
              postCode
              country
              bankInformation
              bankName
              affiliate {
                id
                name
              }
            }
          }
        }
      }
      claimHistoryEntriesConnection(
        after: $after
        before: $before
        first: $first
        last: $last
      ) {
        totalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            id
            details
            content
            createdAt
            claimHistoryEntryType
            resourceId
            author {
              id
              name
              surname
            }
          }
        }
      }
      commentsConnection {
        edges {
          cursor
          node {
            id
            content
            createdAt
            user {
              name
              surname
            }
          }
        }
      }
      flightsPassengerTicketsConnection {
        edges {
          cursor
          node {
            id
            status
            flight {
              id
              delayedFlightId
              delayedFlight {
                id
                utcActualArrivalDate
                utcScheduledArrivalDate
                localScheduledDepartureDate
                delayAtArrival
                cancelled
                airportOrigin {
                  name
                  iata
                }
                airportDestination {
                  name
                  iata
                }
              }
              airportOrigin {
                name
                iata
              }
              airportDestination {
                name
                iata
              }
              airline {
                iata
                name
              }
              blackDay {
                id
              }
              crisisDateInterval {
                id
              }
              number
              localArrivalDate
              localDepartureDate
            }
          }
        }
      }
      legalFormalNotice {
        sentDate
      }
    }
  }
`;

export { CurrentClaim };



// WEBPACK FOOTER //
// ./src/queries/CurrentClaim.js